var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "w-100 h-100 d-flex flex-column justify-content-center align-items-start"
    },
    [
      _c(
        "form",
        {
          staticClass: "search__container",
          attrs: { action: _vm.searchAction, method: "GET", role: "search" }
        },
        [
          _c("h1", { staticClass: "search__title fs-h1-xlarge" }, [
            _c("label", { attrs: { for: "search-input" } }, [
              _vm._v(_vm._s(_vm.searchLabel))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "simple-input-group secondary-text" }, [
            _c("input", {
              ref: "searchInput",
              staticClass: "simple-input",
              attrs: {
                id: "search-input",
                name: "q",
                type: "text",
                "aria-label": _vm.searchText
              }
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn__icon",
                attrs: { type: "submit", "aria-label": _vm.searchLabel }
              },
              [
                _c("i", {
                  staticClass: "icon-arrow",
                  attrs: { "aria-hidden": "true" }
                })
              ]
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }